module.exports = __webpack_public_path__ + "img/big.5d01fa34.jpg";